// extracted by mini-css-extract-plugin
export default {"page":"PaginationItem_page__2z0n8","pageText":"PaginationItem_pageText__9Xtpr","pageSelected":"PaginationItem_pageSelected__vu6Bt"};